/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTieredCharge.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/tiered-charge";

export class AutogenModelTieredCharge<RowType extends ModelRow> extends Endpoint<RowType, RowTieredChargeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTieredCharge extends ModelRow<RowTieredChargeFields> {
	constructor(values?: Partial<RowTieredChargeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTieredChargeFields {
	amount: number;
	charge_code: string;
	charge_type: string;
	company_id: string;
	descr: string;
	id: string;
	number_of_stops: number;
	sequence: number;
	table_id: string;
}

